var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "site-condensed-bar",
      class: {
        "site-condensed-bar--shown": _vm.shown,
        "site-condensed-bar--static": _vm.staticMode,
      },
      style: _vm.barStyle,
      attrs: { role: "banner", "aria-label": "Site navigation" },
    },
    [
      _vm.designed
        ? _c(
            "div",
            { staticClass: "site-condensed-bar__designed" },
            [_vm._t("blocks", null, { blocks: _vm.floatingBlocks })],
            2
          )
        : _c(
            "div",
            {
              staticClass: "site-condensed-bar__inner",
              style: { maxWidth: _vm.pageWidth },
            },
            [
              _c(
                "a",
                {
                  staticClass: "site-condensed-bar__logo",
                  attrs: {
                    href: _vm.staticMode ? null : "/",
                    "aria-label": _vm.siteName,
                  },
                  on: { click: _vm.onLogoClick },
                },
                [
                  _vm.logoSrc
                    ? _c(
                        "img",
                        _vm._b(
                          {
                            staticClass: "site-condensed-bar__img",
                            attrs: { alt: _vm.siteName },
                          },
                          "img",
                          _vm.logoAttrs,
                          false
                        )
                      )
                    : _c("span", { staticClass: "site-condensed-bar__name" }, [
                        _vm._v(_vm._s(_vm.siteName)),
                      ]),
                ]
              ),
              _vm._v(" "),
              _vm.navBlock
                ? _c(
                    "div",
                    { staticClass: "site-condensed-bar__nav" },
                    [_vm._t("nav", null, { block: _vm.navBlock })],
                    2
                  )
                : _vm._e(),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }